import { render, staticRenderFns } from "./GMovableLayoutBox.vue?vue&type=template&id=1ee28d23&scoped=true&"
import script from "./GMovableLayoutBox.vue?vue&type=script&lang=ts&"
export * from "./GMovableLayoutBox.vue?vue&type=script&lang=ts&"
import style0 from "./GMovableLayoutBox.vue?vue&type=style&index=0&id=1ee28d23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee28d23",
  null
  
)

export default component.exports